import { LiveAnnouncer } from '@angular/cdk/a11y';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { AppMasterService } from 'app/business/service/app/app-master.service';
import { NswTrackingResponseModalComponent } from '../nsw-tracking-response-modal/nsw-tracking-response-modal.component';
import { DftTrackingResponseComponent } from '../dft-tracking-response/dft-tracking-response.component';

@Component({
  selector: 'app-dft-tracking-round-list',
  templateUrl: './dft-tracking-round-list.component.html',
  styleUrls: ['./dft-tracking-round-list.component.css']
})
export class DftTrackingRoundListComponent implements OnInit {
  dataSource = new MatTableDataSource<any>();
  displayedColumns: string[] = [
    "index",
    "referenceNo",
    "documentAction",
    "statusName",
    "lastUpdate",
    "action",
  ];
  clickBody: boolean = false;
  form: any = {};
  datas: any = {};

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _liveAnnouncer: LiveAnnouncer,
    private dialog: MatDialog,
    private appMasterService: AppMasterService,
  ) {
    console.log(data);
    this.datas = data;
  }

  ngOnInit() {
    this.loadData();
  }

  ngAfterViewInit() {
    this.paginator.pageIndex = 0;
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  announceSortChange(sortState: Sort) {
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce("Sorting cleared");
    }
  }

  loadData() {
    var request = {
      docId: this.datas.docId,
      docType: this.datas.docType
    };

    this.appMasterService.getDftDocumentItemTrackingList(request).then((res: any) => {
      if (res === 'error') {
        return;
      } else {
        if (res === null) {
          return;
        } else {
          this.dataSource = new MatTableDataSource(res);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        }
      }
    })
  }

  openInfo(e) {
    this.dialog.open(DftTrackingResponseComponent, {
      data: e,
      disableClose: false,
      width: '65vw',
    });
  }

}
